import { Ref, ref } from '@nuxtjs/composition-api';
import useLocalStorage from '@shared/composables/useLocalStorage';
import { StoreDetails } from '@shared/types/stores';

import { BRAND_FULL_NAME } from '~/constants';

const LOCAL_STORAGE_KEY = 'myStore';

const myStore = ref<StoreDetails | null>(null);

export const storeShortName = (name: string) => name.replace(`${BRAND_FULL_NAME} `, '');

const useMyStore = (): {
  myStore: Ref<StoreDetails | null>;
  saveMyStore: (store: StoreDetails) => void;
} => {
  const { load, save } = useLocalStorage();
  myStore.value = load(LOCAL_STORAGE_KEY);

  const saveMyStore = (store: StoreDetails): void => {
    const storeToSave = {
      ...store,
      shortName: store.label || storeShortName(store.name),
    };
    myStore.value = storeToSave;
    save(LOCAL_STORAGE_KEY, storeToSave);
  };

  return { myStore, saveMyStore };
};

export default useMyStore;
